import React from "react";
import renderChildren from "../renderChildren";

export default function StateNode({ node, context, initial = {} }: any) {
  const [state, setReactState] = React.useState(initial || {});

  const setState = React.useCallback((keyOrValue: any, value?: any) => {
    setReactState((current: any) => {
      if (typeof keyOrValue === "function") {
        return keyOrValue(current);
      }

      if (typeof keyOrValue === "string") {
        const nextValue =
          typeof value === "function"
            ? value(current?.[keyOrValue], current)
            : value;

        return {
          ...(current || {}),
          [keyOrValue]: nextValue,
        };
      }

      return {
        ...(current || {}),
        ...(keyOrValue || {}),
      };
    });
  }, []);

  const scopedContext = React.useMemo(() => {
    const nextContext = {
      ...(context || {}),
      state,
      setState,
      setReactState,
    };

    Object.assign(context || {}, {
      state,
      setState,
      setReactState,
    });

    return nextContext;
  }, [context, state, setState]);

  return <>{renderChildren(node?.children || [], scopedContext)}</>;
}
